export const environment = {
    production: true,
    useMockApi: false,
    betaApiUrl: 'https://cointracking.info/beta/api',
    betaApiV3Url: 'https://cointracking.info/beta/api/v3',
    taxReportsUrl: 'https://cointracking.info/interfaces/tax-reports/proxy.php',
    mainAppUrl: 'https://cointracking.info',
    ctLiteApiUrl: '/api',
    expressApiUrl: '/express-api',
    ctEnv: '',

    firebase: {
        apiKey: 'AIzaSyAp3o7KR7HutpQX4-ctZXZhA3MqlFddUZc',
        authDomain: 'auth.coinfox.io',
        projectId: 'cointracking-lite-prod',
        storageBucket: 'cointracking-lite-prod.firebasestorage.app',
        messagingSenderId: '714461966104',
        appId: '1:714461966104:web:740fd321d6d58ecb87b86d',
        useEmulator: false,
    },
    googeClientId: '714461966104-diju255rt8mpjl4e9g48qrjmol7o40sd.apps.googleusercontent.com',
    googleLoginCallbackUrl: 'https://app.coinfox.io/auth/callback',
};
